import { useRecordContext, useUpdate } from 'react-admin'
import { ModeEdit } from '@mui/icons-material'
import { Button } from '@mui/material'

export default function ViewQuoteButton() {
  const record = useRecordContext()
  const [update] = useUpdate()
  const id = record.quoteRequest?.id ?? record.originId

  const onClickHandler = async (record, id) => {
    if (record.quoteRequest) {
      update('lead-notifications', {
        id: record['@id'],
        data: { dismissed: true },
        previousData: record,
      })
    }

    window.open(
      '/#/quote-requests/' + encodeURIComponent('/api/quote-requests/' + id)
    )
  }

  return (
    <Button
      label="View"
      size="small"
      startIcon={<ModeEdit sx={{ mr: '-10px' }} />}
      onClick={() => onClickHandler(record, id)}
    />
  )
}
